import { createFileRoute } from '@tanstack/react-router'
import { VendorPanelDidsPage } from '@/features/vendor-panel/pages/dids-page'

export const Route = createFileRoute('/_authenticated/vendor-panel/dids')({
  component: VendorPanelDidsPage,
})
